// extracted by mini-css-extract-plugin
export default {"tooltip":"RQ-z","arrow":"SQ-z"};